import React, { useState } from 'react'

// @material-ui/icons
import Tabs from '@components/Tabs'
import Axios from '@components/Axios'

import AddEditTerms from './components/AddEditTerms'

import './styles.scss'

const Terms = () => {
  const [run, setRun] = useState(1)
  const [item, setItem] = useState({})

  const onSuccess = ({ data }) => {
    setItem(data)
  }

  const updateList = () => {
    setRun(run => run + 1)
  }

  const tabs = [
    {
      icon: 'add',
      name: 'TERMS_TAB_ADD',
      content: <AddEditTerms item={item} updateList={updateList} />
    }
  ]

  return (
    <Axios run={run} api="pages.terms" onSuccess={onSuccess}>
      <div className="Terms">
        <Tabs headerColor="primary" tabs={tabs} />
      </div>
    </Axios>
  )
}

export default Terms
